'use strict'

module.exports = {
  INIT: 'INIT',
  TERMINATE: 'TERMINATE'
}